import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useCart } from "../contexts/CartContext";
import { useWishlist } from "../contexts/WishlistContext";
import useMobile from "../hooks/useMobile";
import Icon from "./Icon";
import Marquee from "./Marquee";

const NAV = [
  { id: "home", label: "HOME", to: "/" },
  { id: "shop", label: "SHOP", to: "/shop" },
  { id: "new", label: "NEW", to: "/shop?tags=NEW" },
  { id: "sale", label: "SALE", to: "/shop?tags=SALE" },
];

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const mobile = useMobile();
  const { user } = useAuth();
  const { cart } = useCart();
  const { items: wishItems } = useWishlist();
  const [search, setSearch] = useState("");
  const canOpenAdmin = ["admin", "editor"].includes(user?.role);

  const isActive = (to) => {
    if (to === "/" && location.pathname === "/") return true;
    if (to.startsWith("/shop") && location.pathname.startsWith("/shop")) return to === "/shop";
    return false;
  };

  const submit = (e) => {
    e.preventDefault();
    if (search.trim()) navigate(`/shop?q=${encodeURIComponent(search.trim())}`);
  };

  if (mobile) {
    return (
      <header className="fsh-header">
        <Marquee items={["FREE SHIPPING ₩50K+", "NEW DROP FRIDAY", "MEMBERS 10% OFF"]} />
        <div className="fsh-nav" style={{ justifyContent: "space-between" }}>
          <button className="icon-btn" onClick={() => navigate("/shop")}>
            <Icon name="menu" size={20} />
          </button>
          <Link to="/" className="fsh-logo" style={{ fontSize: 22 }}>
            fashion<em>ista.</em>
          </Link>
          <div style={{ display: "flex", gap: 6 }}>
            {canOpenAdmin && (
              <button className="icon-btn admin-nav-btn" onClick={() => navigate("/admin")} title="관리자 패널">
                <Icon name="shield" size={18} />
              </button>
            )}
            <button className="icon-btn" onClick={() => navigate("/shop")}>
              <Icon name="search" size={18} />
            </button>
            <button className="icon-btn" onClick={() => navigate("/cart")}>
              <Icon name="bag" size={18} />
              {cart.count > 0 && <span className="icon-badge">{cart.count}</span>}
            </button>
          </div>
        </div>
      </header>
    );
  }

  return (
    <header className="fsh-header">
      <Marquee
        items={[
          "FREE SHIPPING OVER ₩50,000",
          "NEW DROP EVERY FRIDAY",
          "MEMBERS: 10% OFF FIRST ORDER",
          "RETURNS WITHIN 14 DAYS",
        ]}
      />
      <div className="fsh-nav">
        <Link to="/" className="fsh-logo">
          fashion<em>ista.</em>
        </Link>
        <nav className="fsh-cats">
          {NAV.map((n) => (
            <Link key={n.id} to={n.to} className={isActive(n.to) ? "is-on" : ""}>
              {n.label}
            </Link>
          ))}
        </nav>
        <form className="fsh-search" onSubmit={submit}>
          <Icon name="search" size={16} />
          <input
            placeholder="검색: 니트, 코트, 미니백…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </form>
        <div className="fsh-icons">
          {canOpenAdmin && (
            <button className="admin-panel-btn" onClick={() => navigate("/admin")} title="관리자 패널">
              <Icon name="shield" size={16} />
              <span>관리</span>
            </button>
          )}
          <button
            className="icon-btn"
            onClick={() => navigate(user ? "/mypage" : "/login")}
            title={user ? user.name : "로그인"}
          >
            <Icon name="user" size={18} />
          </button>
          <button className="icon-btn" onClick={() => navigate("/mypage")}>
            <Icon name="heart" size={18} />
            {wishItems.length > 0 && <span className="icon-badge">{wishItems.length}</span>}
          </button>
          <button className="icon-btn" onClick={() => navigate("/cart")}>
            <Icon name="bag" size={18} />
            {cart.count > 0 && <span className="icon-badge">{cart.count}</span>}
          </button>
        </div>
      </div>
    </header>
  );
}
